/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  ExecutableScript,
  ExecuteScriptParams,
  ExecuteScriptResult,
  Script,
  SignerProvider,
  HexString,
} from "@alephium/web3";
import { getContractByCodeHash } from "./contracts";
import { default as CreateConfigScriptJson } from "../CreateConfig.ral.json";
import { default as CreateLiquidPoolScriptJson } from "../CreateLiquidPool.ral.json";
import { default as PoolRouterDemoScriptJson } from "../PoolRouterDemo.ral.json";
import { default as SwapWithoutAccountScriptJson } from "../SwapWithoutAccount.ral.json";
import * as types from "./types";

export const CreateConfig = new ExecutableScript<{
  factory: HexString;
  tickSpacing: bigint;
  fee: bigint;
  feeProtocol: bigint;
  configIndex: bigint;
}>(
  Script.fromJson(CreateConfigScriptJson, "", types.AllStructs),
  getContractByCodeHash
);

export const CreateLiquidPool = new ExecutableScript<{
  factory: HexString;
  token0: HexString;
  token1: HexString;
  configIndex: bigint;
  sqrtPriceX96: bigint;
  rewardToken: HexString;
  tickLower: bigint;
  tickUpper: bigint;
  liquidity: bigint;
  amount0: bigint;
  amount1: bigint;
}>(
  Script.fromJson(CreateLiquidPoolScriptJson, "", types.AllStructs),
  getContractByCodeHash
);

export const PoolRouterDemo = new ExecutableScript<{
  pool_: HexString;
  position_: HexString;
  tick_: HexString;
  word_: HexString;
  factory_: HexString;
  user_: HexString;
  config_: HexString;
  dexAccount_: HexString;
  counter: bigint;
}>(
  Script.fromJson(PoolRouterDemoScriptJson, "", types.AllStructs),
  getContractByCodeHash
);

export const SwapWithoutAccount = new ExecutableScript<{
  dexAccount: HexString;
  pool: HexString;
  tokenIn: HexString;
  tokenOut: HexString;
  zeroForOne: boolean;
  amountSpecified: bigint;
  sqrtPriceLimitX96: bigint;
  data: HexString;
}>(
  Script.fromJson(SwapWithoutAccountScriptJson, "", types.AllStructs),
  getContractByCodeHash
);
